import { Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { API, fileUpload } from "../../../../config";
import Spin from "../../../common/Spin";
import { AddSearchTermSchema } from "../../../common/Validation";
import Form from "./components/Form";
import { getSearchTermDetail } from "./components/SearchTermHelper";
import { getContractorDetail } from "../../sub-contractors/components/SubContractorHelper";
import ProjectSubHeader from "../../components/ProjectSubHeader";

const EditSearchTerm = () => {
  const navigate = useNavigate();
  let existingValues = [];
  let overwrittenFields = [];
  const formValues = useRef();
  const params = useParams();
  const projectId = params?.project_id;
  const [loading, setLoading] = useState(false);
  const [searchTermData, setSearchTermData] = useState([]);
  const searchTermId = params?.term_id;

  const [contractorDetails, setContractorDetails] = useState();
  const [disableState, setDisableState] = useState(false);

  const handleFormSubmit = async (value) => {
    value.chart_of_account_id = value?.chart_of_account_id
      ? value?.chart_of_account_id?.id
      : "";

    value.description = value?.description ? value?.description : "";

    const formData = new FormData();

    formData.append("builder_project_id", projectId);
    formData.append("term", value?.term);
    formData.append("chart_of_account_id", value?.chart_of_account_id);
    formData.append(
      "contact_id",
      contractorDetails?.id ? contractorDetails?.id : ""
    );

    if (value?.description) {
      formData.append("description", value?.description);
    }
    formData.append("_method", "put");
    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.EDIT_TERM}/${searchTermId}`,
        formData
      );
      setLoading(false);
      if (data) {
        toast.success(data?.message);
        navigate("/projects/" + projectId + "/terms");
      }
      return data?.data;
    } catch (error) {
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
        setLoading(false);
      } else {
        toast.error(error?.message);
        setLoading(false);
      }
    }
  };

  const getContractor = async (contractorId) => {
    try {
      setLoading(true);
      const data = await getContractorDetail(contractorId);
      const contractorData = data ? data : {};
      if (contractorData?.id) {
        if (
          contractorData?.account_name &&
          contractorData?.account_number &&
          contractorData?.bsb
        ) {
          setDisableState(false);
        } else {
          setDisableState(true);
          toast.error("Please add bank details of selected contractor.");
        }
      }
      setLoading(false);
    } catch (e) {
      toast.error("Something went wrong.");
    }
  };

  const handleContractorSelect = async (contractor) => {
    setContractorDetails(contractor);
    getContractor(contractor?.id, contractor);
  };

  useEffect(() => {
    async function fetchData() {
      try {
        // await getUsers();
        setLoading(true);
        const data = await getSearchTermDetail(searchTermId);
        setSearchTermData(data);
        setLoading(false);
      } catch (e) {
        setSearchTermData(null);
        setLoading(false);
      }
    }
    fetchData();
  }, [searchTermId]);

  const accountName = searchTermData?.chart_of_account
    ? {
        id: searchTermData?.chart_of_account?.id
          ? searchTermData?.chart_of_account?.id
          : "",
        label:
          searchTermData?.chart_of_account?.name +
          (searchTermData?.chart_of_account?.account_type?.name
            ? " (" + searchTermData?.chart_of_account?.account_type?.name + ")"
            : "") +
          (searchTermData?.chart_of_account?.code
            ? " - " + searchTermData?.chart_of_account?.code.toString()
            : "") +
          (searchTermData?.chart_of_account?.sub_code
            ? "." + searchTermData?.chart_of_account?.sub_code.toString()
            : ""),
        tax: searchTermData?.chart_of_account?.tax,
      }
    : {};

  return (
    <div className="cms-page">
      <div className="page-content-block">
        <div className="full-content-block">
          <ProjectSubHeader title={searchTermData?.term} />
          <div className="content-details">
            <section>
              <Formik
                initialValues={{
                  term: searchTermData?.term,
                  chart_of_account_id: accountName ? accountName : "",
                  contact_id: searchTermData?.contact
                    ? searchTermData?.contact
                    : "",
                  description: searchTermData?.description
                    ? searchTermData?.description
                    : "",
                }}
                enableReinitialize
                innerRef={formValues}
                onSubmit={handleFormSubmit}
                validateOnBlur={true}
                validateOnChange={true}
                validationSchema={AddSearchTermSchema}
              >
                {({
                  values,
                  setErrors,
                  errors,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                }) => {
                  return (
                    <>
                      {loading && <Spin />}
                      <Form
                        values={values}
                        errors={errors}
                        setErrors={setErrors}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        handleSubmit={handleSubmit}
                        setFieldValue={setFieldValue}
                        formValues={formValues}
                        overwrittenFields={overwrittenFields}
                        existingValues={existingValues}
                        projectId={projectId}
                        handleContractorSelect={handleContractorSelect}
                        disableState={disableState}
                      />
                    </>
                  );
                }}
              </Formik>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditSearchTerm;
